module.exports = __webpack_public_path__ + "img/dark&rtl.675e88dd.jpg";